module.exports = __webpack_public_path__ + "static/media/default-image.f065b10c.png";